// @ts-nocheck
import styled from 'styled-components';

export const ReportingDownloadSectionStyle = styled.div`
  box-sizing: border-box;
  color: white;
  width: 100%;
  z-index: 12;
  overflow: auto;
  background-color: ${props => props.theme.backgroundDownloadReport};

  .DateRangePicker_picker {
    z-index: 3;
  }
`;
